import React from "react";
import "cropperjs/dist/cropper.min.css";
import { Box } from "@mui/material";
import styles from "./style.module.css";
import ImageCropper from "./cropper";
import { uploadImage } from "../../../../../../helpers/uploadImageToS3";
import imageCompression from "browser-image-compression";
import { useDispatch, useSelector } from "react-redux";
import { setIsButtonLoading } from "../../../../../../store/slices/loadingSlice";
import { updateSkillImageData } from "../../../../../../store/slices/profile/skillImageSlice";
import axios from "axios";
import { node_server } from "../../../../../../constants";
import {
  setActiveUserSkill,
  setUserSkills,
} from "../../../../../../store/slices/userSlice";

const EditSkillImage = () => {
  const dispatch = useDispatch();
  const { userSkills } = useSelector((state) => state.user);
  const {
    data: { selectedSkillImage },
  } = useSelector((state) => state.skillImage);
  const { activeUserSkill } = useSelector((state) => state.user);

  const handleCrop = async (croppedImage) => {
    try {
      // Convert the Uint8Array to a Blob
      const blob = new Blob([croppedImage], { type: "image/png" });
      const originalBlob = blob;

      // Compress the image using browser-image-compression library
      const options = {
        maxSizeMB: 1, // Set the maximum size of the compressed image to 0.5 MB
        maxWidthOrHeight: 600, // Set the maximum width or height of the compressed image
        useWebWorker: true, // Use a web worker for faster compression
        quality: 1, // Adjust the quality parameter (0.7 is a good starting point)
      };

      const compressedBlob = await imageCompression(originalBlob, options);

      const blobURL = await uploadImage(
        compressedBlob,
        "skill-cover-image-" + activeUserSkill.id + "-v-" + new Date().getTime()
      );

      dispatch(
        updateSkillImageData({
          croppedSkillImage: blobURL,
          isSkillImageModalOpen: false,
        })
      );

      const { data, error } = await axios.post(
        `${node_server}/api/skills/update`,
        {
          skillCoverImage: blobURL,
        },
        {
          params: { id: activeUserSkill.id },
          withCredentials: true,
        }
      );

      if (error) console.log(error);
      if (data) {
        const currentSkill = data.filter(
          (skill) => skill.id === activeUserSkill.id
        )[0];
        const updatedSkills = userSkills.map((skill) => {
          if (skill.id === activeUserSkill.id) {
            dispatch(setActiveUserSkill({ ...skill, ...currentSkill }));
            return { ...skill, ...currentSkill };
          } else {
            return skill;
          }
        });
        dispatch(setUserSkills(updatedSkills));
      }

      // handle original image upload
      if (selectedSkillImage !== activeUserSkill.originalCoverImage) {
        const response = await fetch(selectedSkillImage);
        const blobData = await response.blob();

        // Compress the image using browser-image-compression library
        const options = {
          maxSizeMB: 1, // Set the maximum size of the compressed image
          maxWidthOrHeight: 600, // Set the maximum width or height of the compressed image
          useWebWorker: true, // Use a web worker for faster compression
          quality: 1,
        };

        const compressedBlob = await imageCompression(blobData, options);

        const originalImageUrl = await uploadImage(
          compressedBlob,
          "original-cover-image-" +
            activeUserSkill.id +
            "-v-" +
            new Date().getTime()
        );

        const { data, error } = await axios.post(
          `${node_server}/api/skills/update`,
          {
            originalCoverImage: originalImageUrl,
          },
          {
            params: { id: activeUserSkill.id },
            withCredentials: true,
          }
        );

        if (error) console.error(error);
        if (data) {
          const currentSkill = data.filter(
            (skill) => skill.id === activeUserSkill.id
          )[0];
          const updatedSkills = userSkills.map((skill) => {
            if (skill.id === activeUserSkill.id) {
              dispatch(setActiveUserSkill({ ...skill, ...currentSkill }));
              return { ...skill, ...currentSkill };
            } else {
              return skill;
            }
          });

          dispatch(setUserSkills(updatedSkills));
        }
      }

      dispatch(updateSkillImageData({ selectedSkillImage: null }));

      dispatch(setIsButtonLoading(false));
    } catch (error) {
      console.error(error);
      dispatch(setIsButtonLoading(false));
    }
  };

  const handleCancel = () => {
    dispatch(
      updateSkillImageData({
        croppedSkillImage: null,
        selectedSkillImage: null,
      })
    );
  };

  return (
    <Box className={styles.parent}>
      <Box className={styles.container}>
        <ImageCropper onCrop={handleCrop} onCancel={handleCancel} />
      </Box>
    </Box>
  );
};

export default EditSkillImage;
